import { GiveawayConfigApiClient } from '@fourthwall/services/dist/GiveawayConfigApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useGiveawayConfigStreamQuery = createQueryHook(
  GiveawayConfigApiClient.getGiveawayConfigStream,
  {
    queryKey: ['giveawayConfigStream'],
  },
)
